/*
  Footer F&NT v20 (oct 2026). Lo carga sections/footer.liquid (defer).
  - Banda en movimiento: se pausa cuando no está en pantalla (ahorra trabajo al navegador).
  - Newsletter: suscribe directo a la lista de Klaviyo del ajuste de la sección (Email List,
    que dispara la Bienvenida con FNT10), con origen "Footer" y sin recargar la página.
    Si Klaviyo no responde, envía el formulario de clientes de Shopify como antes.
  - Anti-bots (v30, 18 oct 2026): campo trampa oculto que una persona no ve ni llena, y
    mínimo de 3 s desde que carga la página. Si falla cualquiera de los dos, se muestra el
    mensaje de "Listo" pero no se manda nada a Klaviyo ni a Shopify. Origen: 2 bots
    suscritos por el footer (13 y 17 oct) que la protección de Klaviyo no detectó.
*/
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var OK_TEXT = '¡Listo! Revisa tu correo para recibir tu código.';
  var MIN_MS = 3000;
  var HP_NAME = 'fnt_hp_sitio';

  function initMarquee(root) {
    var mq = root.querySelector('[data-fnt-mq]');
    if (!mq || !('IntersectionObserver' in window)) return;
    mq.classList.add('is-paused');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { mq.classList.toggle('is-paused', !e.isIntersecting); });
    }).observe(mq);
  }

  // Campo trampa: fuera de la pantalla, sin tabulador y sin autocompletar
  function addTrap(form) {
    if (form.querySelector('[name="' + HP_NAME + '"]')) return;
    var wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText = 'position:absolute!important;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;';
    wrap.innerHTML = '<label>Sitio web <input type="text" name="' + HP_NAME + '" tabindex="-1" autocomplete="off" value=""></label>';
    form.appendChild(wrap);
  }

  function showOk(form) {
    var field = form.querySelector('[data-fnt-news-field]');
    var ok = document.createElement('p');
    ok.className = 'fnt-footer__form-msg fnt-footer__form-msg--ok';
    ok.setAttribute('role', 'status');
    ok.textContent = OK_TEXT;
    if (field) field.replaceWith(ok);
  }

  function initNews(root) {
    var form = root.querySelector('[data-fnt-news]');
    if (!form || !window.fetch) return;
    var started = Date.now();
    addTrap(form);
    form.addEventListener('submit', function (ev) {
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      var err = form.querySelector('.fnt-footer__form-msg--error');
      var trap = form.querySelector('[name="' + HP_NAME + '"]');
      var list = form.getAttribute('data-list');
      var company = form.getAttribute('data-company');

      // Bot: trampa llena o envío demasiado rápido. No se manda nada.
      if ((trap && trap.value) || Date.now() - started < MIN_MS) {
        ev.preventDefault();
        showOk(form);
        return;
      }

      if (!input || !list || !company) return; // sin datos de Klaviyo: envío normal de Shopify
      ev.preventDefault();
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        if (err) err.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      if (err) err.hidden = true;
      input.removeAttribute('aria-invalid');
      if (btn) btn.disabled = true;
      var fallback = function () { HTMLFormElement.prototype.submit.call(form); };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (r) {
        if (!r.ok) return fallback();
        showOk(form);
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
      }).catch(fallback);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fnt-footer]').forEach(function (root) {
      if (root.dataset.fntReady) return;
      root.dataset.fntReady = '1';
      initMarquee(root);
      initNews(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
